import { Config } from "config"
import { getCountBranch } from "utils/app.utils"
import { getSecureItem } from "utils/storage"
import { KEY_STORAGE } from "./common"
import { PACKAGE_DENTAL_V1 } from "./package/dental/v1"
import { PACKAGE_DENTAL_V2 } from "./package/dental/v2"
import { PACKAGE_PLUS_V1 } from "./package/plus/v1"
import { PACKAGE_PLUS_V2 } from "./package/plus/v2"

export enum PACKAGE_TYPE {
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
  ULTRA = 'ULTRA'
}

export enum PACKAGE_ADDONS {
  ADDON_APPLICATION_NOTICE = 'ADDON_APPLICATION_NOTICE',
  ADDON_EMAIL_NOTICE = 'ADDON_EMAIL_NOTICE',
  ADDON_LINE_NOTIFY = 'ADDON_LINE_NOTIFY',
  ADDON_FORM_RETRIEVE = 'ADDON_FORM_RETRIEVE',
  // ADDON_DOCTOR_NOTE = 'ADDON_DOCTOR_NOTE',
  ADDON_DOCTOR_NOTE = 'DOCTOR_NOTE',
  ADDON_HOME = 'HOME',
  ADDON_DASHBOARD = 'DASHBOARD',
  ADDON_REGISTER_APP = 'REGISTER_APP',
  ADDON_EXTRA = 'EXTRA',
  ADDON_INSTALLMENT = 'INSTALLMENT',
  ADDON_BANNER = 'BANNER',
  ADDON_ABOUT_US = 'ABOUT_US',
  ADDON_SERVICE = 'SERVICE',
  ADDON_PRICE_LIST = 'PRICE_LIST',
  ADDON_REVIEW = 'REVIEW',
  ADDON_ARTICLE = 'ARTICLE',
  ADDON_CONTACT_US = 'CONTACT_US',
  ADDON_PROMOTIONS = 'PROMOTIONS',
  ADDON_NEWS = 'NEWS',
  ADDON_RETROSPECTIVE_ORDER = 'RETROSPECTIVE_ORDER',
  ADDON_RETROSPECTIVE_EDIT = 'RETROSPECTIVE_EDIT',
  ADDON_WAREHOUSES = 'WAREHOUSES',

  ADDON_TREATMENT_TEMPLATE = 'ADDON_TREATMENT_TEMPLATE',
  ADDON_TREATMENT_TEMPLATE_TYPE = 'ADDON_TREATMENT_TEMPLATE_TYPE',

  ADDON_TREATMENT_PLAN_MANAGE = 'TREATMENT_PLAN_MANAGE',
  ADDON_TREATMENT_PLAN_TYPE = 'TREATMENT_PLAN_TYPE',
  ADDON_TREATMENT_PLAN = 'TREATMENT_PLAN',

  ADDON_TREATMENT_COURSE_MANAGE = 'TREATMENT_COURSE_MANAGE',
  ADDON_TREATMENT_COURSE_TYPE = 'TREATMENT_COURSE_TYPE',
  ADDON_TREATMENT_COURSE = 'TREATMENT_COURSE',

  ADDON_DOCTOR_NOTE_TYPE_FORM = 'DOCTOR_NOTE_TYPE_FORM',
  ADDON_DOCTOR_NOTE_FORM = 'DOCTOR_NOTE_FORM',
  ADDON_DOCTOR_NOTE_TYPE_PIC = 'DOCTOR_NOTE_TYPE_PIC',
  ADDON_DOCTOR_NOTE_PIC = 'DOCTOR_NOTE_PIC',

  ADDON_RECALL = 'RECALL',
  ADDON_RECALL_LIST = 'RECALL_LISTS',
  ADDON_PRODUCTS = 'PRODUCTS',
  ADDON_LAB = 'LAB',
  ADDON_LAB_MANAGEMENT = 'LAB_MANAGEMENT',
  ADDON_LAB_LIST = 'LAB_LIST',
  ADDON_LAB_TYPE = 'LAB_TYPE',
  ADDON_LAB_GROUP = 'LAB_GROUP',
  ADDON_LAB_COMPANY = 'LAB_COMPANY',

  ADDON_X_RAY = 'X_RAY',
  ADDON_XRAY_FILM_TYPE = 'XRAY_FILM_TYPE',
  ADDON_IMAGE_TYPE = 'IMAGE_TYPE',

  ADDON_SALARY = 'SALARY',
  ADDON_INCOME_EXPENSES = 'INCOME_EXPENSES',
  ADDON_ADVANCE = 'ADVANCE',

  ADDON_SETING_DOCTOR_NOTE = 'DOCTOR_NOTE',
  ADDON_WEB_MANAGE = "WEB_MANAGE",

  ADDON_APPROVELIST = "USAGE_APPROVAL_MANAGEMENT",
  ADDON_DEFAULT_PRODUCT = 'DEFAULT_PRODUCT',

  ADDON_FOLLOWUP = "FOLLOW_UP",

  /** จัดการชั้นของหน้าสาขา */
  ADDON_BRANCH_PAGE_LAYER = 'BRANCH_PAGE_LAYER',

  /** ฟังก์ชันราคาช่วง */
  ADDON_PRICE_RANGE = 'PRICE_RANGE',

  /** ฟังก์ชันค่า DCC */
  ADDON_DCC = 'DCC',

  /** เซ็นขอค้างชำระ – การเงินต้องเซ็น */
  ADDON_REQUIRE_FINANCE_ACKNOWLEDGE = 'REQUIRE_FINANCE_ACKNOWLEDGE',

  /** คนไข้ใหม่-คนไข้เก่า (การแสดงประเภทผู้ป่วย) */
  ADDON_NEW_OLD_PATIENT = 'NEW_OLD_PATIENT',

  /** แจ้งเตือนเมื่อไม่เลือกหัตถการ */
  ADDON_ALERT_NO_TREATMENT = 'ALERT_NO_TREATMENT',

  /** แสดงการแจ้งเตือนเมื่อไม่เลือกยา */
  ADDON_ALERT_NO_MEDICINE = 'ALERT_NO_MEDICINE',

  /** แจ้งเตือนระบุซี่ฟันก่อนชำระเงิน (จัดการสาขา + หน้าการรักษา) */
  ADDON_ALERT_TEETH_BEFORE_PAYMENT = 'ALERT_TEETH_BEFORE_PAYMENT',

  /** จัดการใบแจ้งค่าบริการรักษา (เปิด tab ใหม่ + footer ชื่อแคชเชียร์) */
  ADDON_TREATMENT_FEE_STATEMENT = 'TREATMENT_FEE_STATEMENT'
}

const checkPackageVersion = () => {
  let info: any = getSecureItem(KEY_STORAGE.CLINIC_INFO)
  if (info) info = JSON.parse(info)
  else info = { packageVersion: 'v2' }


  const packageVersion = info?.packageVersion
  const product = Config.REACT_APP_CLINIC_THEME || 'DENTAL'
  if (product === 'PLUS' && packageVersion === 'v1') return PACKAGE_PLUS_V1
  else if (product === 'PLUS' && packageVersion === 'v2') return PACKAGE_PLUS_V2
  else if (product === 'DENTAL' && packageVersion === 'v1') {
    return PACKAGE_DENTAL_V1
  }
  else {
    return PACKAGE_DENTAL_V2
  }
}

export const PACKAGE = checkPackageVersion()

export interface PackageItem {
  time: string
  package: PACKAGE_TYPE
  packageVersion: string
  packageExpired: string
  countBranch: number
  enabledApp: number
}

export const userLimit = (packageType: PACKAGE_TYPE) => {
  if (packageType === PACKAGE_TYPE.STANDARD) return 10 * getCountBranch()
  else if (packageType === PACKAGE_TYPE.PREMIUM) return 30 * getCountBranch()
  else return 0
}